var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isShowTips)?_c('div',{staticClass:"prism-player",staticStyle:{"height":"300px"},attrs:{"id":_vm.myVideo}}):_c('p',{staticStyle:{"text-align":"center","margin-top":"20px"}},[_vm._v("当前视频正在转码中，请稍后刷新重试！")])}
var staticRenderFns = []

export { render, staticRenderFns }